export default __webpack_public_path__ + "static/media/873.4439c9ff.gif";